import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Snake from '../components/Snake';
var IndexPage = function IndexPage() { return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, { title: "Lihs Home" }), /*#__PURE__*/ React.createElement("h1", null, "\u4F60\u597D\uFF0CWorld"), /*#__PURE__*/ React.createElement(Link, { to: "/blog/" }, /*#__PURE__*/ React.createElement("h1", null, "Go to blog")), /*#__PURE__*/ React.createElement(Snake, null)); };
export default IndexPage;
